import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { JuniorHero } from "@/components/junior/JuniorHero";
import { JuniorPackages } from "@/components/junior/JuniorPackages";
import { JuniorDetails, JuniorWhy, JuniorParents } from "@/components/junior/JuniorInfo";
import { JuniorBookingForm } from "@/components/junior/JuniorBookingForm";
import { SchoolsEnquiry } from "@/components/junior/SchoolsEnquiry";
import { JuniorVibe } from "@/components/junior/JuniorVibe";
import { GiftVoucherSection } from "@/components/junior/GiftVoucherSection";
import { JR_FAQ } from "@/components/junior/juniorData";
import { ChristmasVoucherBanner } from "@/components/vouchers/ChristmasVoucherBanner";

const Marquee = () => (
  <div className="overflow-hidden py-4 bg-lime-300 -rotate-1 scale-[1.02]" aria-hidden="true">
    <div className="marquee-track flex w-max gap-10">
      {Array.from({ length: 2 }).flatMap((_, k) =>
        ["Make friends", "Build confidence", "Safe & supervised", "Club-standard gear", "Express yourself", "Summer holidays"].map((t) => (
          <span key={`${k}-${t}`} className="font-display text-2xl md:text-3xl font-bold uppercase text-black whitespace-nowrap">{t} ✦</span>
        ))
      )}
    </div>
  </div>
);

const Faq = () => (
  <section className="py-20 md:py-24 bg-dream-surface" data-testid="jr-faq">
    <div className="max-w-3xl mx-auto px-6">
      <h2 className="font-display text-3xl font-bold text-white mb-8">Parent FAQs</h2>
      <Accordion type="single" collapsible className="space-y-3">
        {JR_FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="rounded-2xl border border-white/10 px-5 bg-white/[0.02]" data-testid={`jr-faq-${i}`}>
            <AccordionTrigger className="text-white text-left font-semibold">{f.q}</AccordionTrigger>
            <AccordionContent className="text-white/65">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default function JuniorDJAcademy() {
  const [packageId, setPackageId] = useState("junior_dj_starter");
  const selectPackage = (id) => {
    setPackageId(id);
    document.getElementById("jr-book")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-dream-bg min-h-screen overflow-x-hidden" data-testid="junior-dj-academy-page">
      <JuniorHero />
      <ChristmasVoucherBanner scope="junior" />
      <Marquee />
      <JuniorVibe />
      <JuniorPackages onSelect={selectPackage} />
      <JuniorWhy />
      <JuniorDetails />
      <JuniorParents />
      <JuniorBookingForm packageId={packageId} setPackageId={setPackageId} />
      <GiftVoucherSection />
      <Faq />
      <SchoolsEnquiry />
    </div>
  );
}
